import React from "react";
import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const Bar = styled.div`
  height: 14px;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    #e5e7eb 25%,
    #f3f4f6 50%,
    #e5e7eb 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
  margin-bottom: 8px;

  &:nth-child(1) { width: 85%; }
  &:nth-child(2) { width: 70%; }
  &:nth-child(3) { width: 55%; }
`;

const Container = styled.div`
  padding: 8px 0;
`;

export default function SkeletonLoader() {
  return (
    <Container>
      <Bar data-testid="skeleton-bar" />
      <Bar data-testid="skeleton-bar" />
      <Bar data-testid="skeleton-bar" />
    </Container>
  );
}
